<template>
  <div v-if="load">
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Offer Division</v-toolbar-title>
        <!-- <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer> -->
      </v-toolbar>
      <v-card-text>
        <!-- <v-row justify="center">
                    <v-col sm="3">
                        <h3>Offer Division</h3>
                    </v-col>
                </v-row> -->
        <v-row justify="center" dense>
          <v-col sm="2">
            <v-icon color="error"> *</v-icon>
            <v-combobox dense rounded required v-model="ay" :items="division_data.academic_year_list"
              item-text="Application Status Data" label="Academic Year" outlined persistent-hint
              hint="Please Select Academic Year" />
          </v-col>
          <v-col sm="2">
            <v-icon color="error"> *</v-icon>
            <v-autocomplete dense rounded required v-model="std" :items="division_data.standard_list"
              item-text="Application Status Data" label="Standard" outlined persistent-hint
              hint="Please Select Standard" />
          </v-col>
          <v-col sm="2">
            <v-icon color="error"> *</v-icon>
            <v-autocomplete dense rounded required v-model="division" :items="division_data.all_div"
              item-text="Divisions" label="Divisions" outlined persistent-hint hint="Please Select Division" />
          </v-col>
          <v-col sm="2">
            <v-icon> </v-icon>
            <v-autocomplete dense rounded v-model="class_teacher" :items="division_data.teachers"
              item-text="Class Teacher" label="Class Teacher" outlined persistent-hint
              hint="Please Select Class Teacher" />
          </v-col>

          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-text-field outlined rounded dense required v-model="capacity" label="Division Capacity" type="text"
              hint="In numbers like 1,2,...">
            </v-text-field>
          </v-col>
          <v-col sm="2">
            <v-btn class="mt-6 button" @click="saveOfferDivision" :loading="fetch_btn_load">
              Offer
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Offered Division List</v-toolbar-title>
        <!-- <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer> -->
      </v-toolbar>
      <div v-if="filtered_div_list">
        <!-- export btn code -->

        <!-- <v-col cols="12" sm="3" md="3" v-if="filtered_div_list != null">
          <v-btn color="success" dark class="exportbtn" outlined rounded>
            <download-excel
              class="mar"
              :data="filtered_div_list"
              :fields="table_fields"
              worksheet="OfferDivision"
              name="OfferDivision.xls"
            >
              <v-icon dark>mdi-file-excel</v-icon> Export
            </download-excel>
          </v-btn>
        </v-col> -->
        <v-col cols="6" sm="2" md="2">
          <v-btn class="ma-2 no-display " rounded color="success" outlined v-if="filtered_div_list != 0"
            @click="fnExcelReport('my-table-id', 'OfferDivision')" :loading="loader"><v-icon
              color="success">mdi-export</v-icon>Export</v-btn>
        </v-col>
        <!-- export btn code end-->
        <div id="my-table-id">
          <v-data-table :headers="headers" :items="filtered_div_list" sort-by="std" dense class="elevation-1 mytable"
            :search="search" items-per-page="-1">
            <template v-slot:top>
              <v-toolbar flat color="white" align="center" justify="center">
                <!-- <v-toolbar-title>Offered Division List</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider> -->
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                </v-text-field>
              </v-toolbar>
            </template>
            <template v-slot:item.isactive="{ item }">
              <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                @change="toggle(item)"></v-switch>
            </template>
            <template v-slot:item.checker="{ item }">
              {{ item.checker ? item.checker : '--' }}
            </template>
            <template v-slot:item.action="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-avatar style size="25" class="edit-avatar">
                    <v-icon class="edit-v-icon mr-2" @click="editDivisionOffering(item)" title="edit"
                      style>edit</v-icon>
                  </v-avatar>
                </template>
                <span>Edit</span>
              </v-tooltip>
            </template>

            <!-- <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>-->
          </v-data-table>
        </div>
      </div>
      <v-dialog v-model="dialog" max-width="500px">
        <v-card class="mx-auto">
          <v-card-title class="toolbar"> Edit Division Offering </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-combobox dense outlined rounded required v-model="editedItem.ay"
                  :items="division_data.academic_year_list" item-text="Application Status Data" label="Academic Year"
                  persistent-hint :disabled="editedIndex != -1" :hint="editedIndex == -1 ? '' : 'noneditable'"
                  :filled="editedIndex == -1 ? false : true" />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-autocomplete dense outlined rounded required v-model="editedItem.std"
                  :items="division_data.standard_list" item-text="Application Status Data" label="Standard"
                  persistent-hint :disabled="editedIndex != -1" :hint="editedIndex == -1 ? '' : 'noneditable'"
                  :filled="editedIndex == -1 ? false : true" />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12">
                <v-autocomplete dense outlined rounded required v-model="editedItem.division"
                  :items="division_data.all_div" item-text="Divisions" label="Divisions" persistent-hint
                  :disabled="editedIndex != -1" :hint="editedIndex == -1 ? '' : 'noneditable'"
                  :filled="editedIndex == -1 ? false : true" />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12">
                <v-text-field outlined rounded dense v-model="editedItem.capacity" label="Capacity" />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12">
                <v-autocomplete dense outlined rounded v-model="editedItem.class_teacher"
                  :items="division_data.teachers" item-text="Class Teacher" label="Class Teacher" />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-autocomplete dense outlined rounded v-model="editedItem.checker"
                  :items="division_data.teachers" item-text="Checker" label="Checker" />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="button" @click="dialog = false">Close</v-btn>
            <v-btn class="button" @click="saveEditOfferDivision" :loading="edit_save_btn_load">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    dialog: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    load: false,
    fetch_btn_load: false,
    //1
    division_data: "",
    division: null,
    ay: null,
    std: null,
    capacity: null,
    class_teacher: null,
    search: null,
    checker:null,
    //2
    filtered_div_list: null,

    // extraBreadcrumbItems: [
      

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    headers: [
      { text: "Academic Year", value: "ay", sortable: true },
      { text: "Standard", value: "std", sortable: true },
      { text: "Division", value: "division", sortable: true },
      { text: "Capacity", value: "capacity", sortable: true },
      { text: "Class Teacher", value: "class_teacher", sortable: true },
      { text: "Checker", value: "checker", sortable: true },
      {
        text: "Status",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Action", value: "action", sortable: false },
    ],

    table_fields: {
      "Academic Year": "ay",
      Standard: "std",
      Division: "division",
      Capacity: "capacity",
      "Class Teacher": "class_teacher",
    },
    editedIndex: -1,
    editedItem: {
      id: "",
      ay: "",
      std: "",
      division: "",
      capacity: "",
      class_teacher: "",
      checker:""
    },
    //loader
    edit_save_btn_load: false,
  }),
  watch: {
    // division() {
    //   this.getoffereddiv();
    // },
    // std() {
    //   this.getoffereddiv();
    // },
    ay() {
      this.getoffereddiv();
    },
  },
  methods: {
    fnExcelReport(id, name) {
      let tab_text = `<table border='1px'>
    <tr>
      <th>Academic Year</th>
      <th>Standard</th>
      <th>Division</th>
      <th>Capacity</th>
      <th>Class Teacher</th> 
      <th>Checker</th> 
    </tr>`;

      this.filtered_div_list.forEach((item, index) => {
        tab_text += `
      <tr>
        <td>${item.ay}</td>
        <td>${item.std}</td>
        <td>${item.division}</td>
        <td>${item.capacity}</td>
        <td>${item.class_teacher}</td>
        <td>${item.checker ? item.checker : '--'}</td>
      </tr>`;
      });

      tab_text += '</table>';

      const blob = new Blob([tab_text], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    saveEditOfferDivision() {
      //api-3
      this.edit_save_btn_load = true;
      console.log(
        "editedItem:" +
        this.editedItem.id +
        "->" +
        this.editedItem.class_teacher
      );
      const formData = {
        div_off_id: this.editedItem.id,
        class_teacher: this.editedItem.class_teacher,
        capacity: this.editedItem.capacity,
        checker : this.editedItem.checker
      };
      axios
        .post("/admission/saveEditOfferDivision", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            if (res.data.form_saved == "YES") {
              this.showSnackbar("#4caf50", "Edit successfully!!!"); // show snackbar
              this.getoffereddiv();
            } else {
              this.showSnackbar("#b71c1c", "Unable to edit!!!"); // show snackbar
            }
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.dialog = false;
          this.edit_save_btn_load = false;
        });
    },
    editDivisionOffering(item) {
      this.editedIndex = this.filtered_div_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    getoffereddiv() {
      this.fetch_btn_load = true;
      this.filtered_div_list = null;
      if (this.ay != null) {
        const formData = {
          ay: this.ay,
        };
        axios
          .post("/admission/getoffereddiv", formData)
          .then((res) => {
            if (res.data.msg == "200") {
              this.filtered_div_list = res.data.filtered_div_list;
              this.fetch_btn_load = false;
            } else {
              //error
            }
          })
          .catch((error) => {
            window.console.log(error);
          })
          .finally(() => {
            //close loader
          });
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    init_call() {
      this.getoffereddiv();

      axios
        .post("/admission/offerDivision")
        .then((res) => {
          if (res.data.msg == "200") {
            this.division_data = res.data.division_data;
            this.ay = this.division_data.current_academic_year;
            this.load = true;
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
        });
    },
    saveOfferDivision() {
      if (this.division != null && this.std != null && this.ay != null) {
        const formData = {
          ay: this.ay,
          std: this.std,
          division: this.division,
          class_teacher: this.class_teacher,
          capacity: this.capacity,
        };
        axios
          .post("/admission/saveOfferDivision", formData)
          .then((res) => {
            if (res.data.form_saved == "NO") {
              this.showSnackbar("#b71c1c", "Division not offered"); // show snackbar
            } else if (res.data.form_saved == "YES") {
              this.showSnackbar("#4caf50", "Division offered successfully!!!"); // show snackbar
              this.getoffereddiv();
            } else {
              this.showSnackbar("#b71c1c", "Division already offered!!!"); // show snackbar
            }
          })
          .catch((error) => {
            window.console.log(error);
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          })
          .finally(() => {
            //close loader
          });
      } else {
        this.showSnackbar("#b71c1c", "Please select mandatory fields"); // show snackbar
      }
    },
    toggle(item) {
      const data = {
        section_id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/admission/toggleOfferDivision", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Offer Division Status Changed!"); // show snackbar
          } else if (res.data.code == "NA") {
            this.showSnackbar("#4caf50", "Something went wrong, Please try again later!"); // show snackbar
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
  mounted() {
    this.init_call();
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}

.mytable2 /deep/ thead th {
  background: #0f2027 !important;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027) !important;
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027) !important;
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
